import { render, staticRenderFns } from "./settingCompanyPhases.vue?vue&type=template&id=3fe83fc6&scoped=true&"
import script from "./settingCompanyPhases.vue?vue&type=script&lang=js&"
export * from "./settingCompanyPhases.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyPhases.vue?vue&type=style&index=0&id=3fe83fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe83fc6",
  null
  
)

export default component.exports